import styled from '@emotion/styled'
import * as React from 'react'
import { defineMessages } from 'react-intl'
import Footer from '../../components/footer'
import { Locale } from '../../domain'
import { AppVariant } from '../../domain/appVariant'
import { useEnv } from '../../lib/env'

const messageDescriptors = {
  headings: defineMessages({
    conceptHeading: {
      id: 'compositions.impressum.concept.heading',
      defaultMessage: 'Projektleitung und Konzept',
    },
    designHeading: {
      id: 'compositions.impressum.design.heading',
      defaultMessage: 'Gestaltung',
    },
    programmingHeading: {
      id: 'compositions.impressum.programming.heading',
      defaultMessage: 'Programmierung',
    },
    translationHeading: {
      id: 'compositions.impressum.translation.heading',
      defaultMessage: 'Übersetzung',
    },
    liveTextHeading: {
      id: 'oS6qzMR',
      defaultMessage: 'Live-Texte',
      description: 'Impressum: Heading for live text authors',
    },
    sourcesHeading: {
      id: 'compositions.impressum.sources.heading',
      defaultMessage: 'Quellen',
    },
  }),
  content: {
    ballot: defineMessages({
      conceptContent: {
        id: 'compositions.impressum.concept.content[ballot]',
        defaultMessage: 'Marc Brupbacher und Titus Plattner',
      },
      designContent: {
        id: 'compositions.impressum.design.content[ballot]',
        defaultMessage: 'Matthias Saner, Sanerstudio',
      },
      programmingContent: {
        id: 'compositions.impressum.programming.content[ballot]',
        defaultMessage: 'Kaspar Manz (Interaktiv-Team)',
      },
      translationContent: {
        id: 'compositions.impressum.translation.content[ballot]',
        defaultMessage: 'Mathieu Rudaz',
      },
      sourcesContent: {
        id: 'compositions.impressum.sources.content[ballot]',
        defaultMessage: 'Bundesamt für Statistik BfS, gfs.bern, sda, Tamedia, SRF',
      },
    }),
    election: defineMessages({
      conceptContent: {
        id: 'compositions.impressum.concept.content',
        defaultMessage: 'Marc Brupbacher und Titus Plattner',
      },
      designContent: {
        id: 'compositions.impressum.design.content',
        defaultMessage: 'Matthias Saner, Sanerstudio',
      },
      programmingContent: {
        id: 'compositions.impressum.programming.content',
        defaultMessage: 'Kaspar Manz (Interaktiv-Team)',
      },
      translationContent: {
        id: 'compositions.impressum.translation.content',
        defaultMessage: 'Mathieu Rudaz',
      },
      liveTextContent: {
        id: 'YVJCjtb',
        defaultMessage: 'Tamedia',
        description: 'Impressum: Content for live text authors',
      },
      sourcesContent: {
        id: 'compositions.impressum.sources.content',
        defaultMessage: 'Bundesamt für Statistik BfS, gfs.bern, sda, Tamedia, SRF',
      },
    }),
  },
}

// region Styles

const Root = styled('div')``

// endregion

//TODO support hashtags; currently not implemented in Footer component

interface Props {
  /** Whether the ballot or election variant is being shown. Used to get the correct article ID. Defaults to "ballot" */
  appVariant?: AppVariant
}

const Impressum = React.memo(({ appVariant = 'ballot' }: Props) => {
  const { intl } = useEnv()
  if (appVariant === 'docs') {
    return null
  }

  const { headings } = messageDescriptors
  const content = messageDescriptors.content[appVariant]

  return (
    <Root>
      <Footer
        credits={
          [
            'liveTextContent' in content
              ? [intl.formatMessage(headings.liveTextHeading), intl.formatMessage(content.liveTextContent)]
              : null,
            [intl.formatMessage(headings.sourcesHeading), intl.formatMessage(content.sourcesContent)],
          ].filter(Boolean) as [string, string][]
        }
        locale={intl.locale.split('-')[0] as Locale}
      />
      {/*
        <Footer
          articleId={articleId}
          hidePortfolioTeaser
          hideUserFeedback
          credits={
            [
              'liveTextContent' in content
                ? [intl.formatMessage(headings.liveTextHeading), intl.formatMessage(content.liveTextContent)]
                : null,
              [intl.formatMessage(headings.sourcesHeading), intl.formatMessage(content.sourcesContent)],
            ].filter(Boolean) as [string, string][]
          }
          locale={intl.locale.split('-')[0] as Locale}
        />
        */}
    </Root>
  )
})

export { Impressum }
export default Impressum
